import { Box, Stack, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { useI18n } from '../../../../../../application/language/useI18n';
import { UserSystemRoleModelPermissionMap } from '../../../../../../service/systemRole/entity/actions/UserSystemRoleModelPermissionMap';
import { IProjectView } from '../store/model/IProjectView';
import { ProjectInfoDomain } from '../store/ProjectInfoDomain';
import { InvitationLink } from './InvitationLink';
import { InvitationLinkSettings } from './InvitationLinkSettings';

export const InvitationLinksWrapper = observer(
  ({ project, domain }: { project: IProjectView; domain: ProjectInfoDomain }) => {
    const isAdmin = domain.layoutDomain.userHaveAnyAccess([UserSystemRoleModelPermissionMap['global-allow-any']]);
    const links = domain.ui.invitationLinks.list || [];
    const { translate } = useI18n();
    const location = useLocation();
    const hasApplicationPath = location.pathname.includes('application');

    return (
      <Box sx={{ paddingBottom: '10px' }}>
        <Typography variant="h5">{translate('projectPage.team')}</Typography>
        {isAdmin && !hasApplicationPath && (
          <Typography color="#BEC2C3" variant="subtitle2" sx={{ maxWidth: 600 }}>
            {translate('projectPage.teamDescription')}
          </Typography>
        )}
        {isAdmin && !hasApplicationPath && (
          <Stack direction="row" alignItems="center" gap={1}>
            <InvitationLink domain={domain} projectId={project.id} />
            {!!links.length && <InvitationLinkSettings domain={domain} projectId={project.id} />}
          </Stack>
        )}
      </Box>
    );
  },
);
